export const en = {
  productsPage: {
    title: "All Products & Offers",
    navLabel: "Products",
    subtitle: "All available hosting products at a glance",
    searchPlaceholder: "Search products or providers...",
    filterAll: "All Categories",
    filterAllProviders: "All Providers",
    noProducts: "No products found.",
    free: "Free",
    viewOffer: "View Offer",
    viewDetail: "Details",
    toProduct: "To Product",
    toProvider: "To Provider",
    filterProvider: "Provider",
    loadingProducts: "Loading products...",
    productsCount: (n) => `${n} product${n !== 1 ? 's' : ''} found`,
    thProduct: "Product",
    thProvider: "Provider",
    thPrice: "Price",
    thCpu: "CPU",
    thRam: "RAM",
    thStorage: "Storage",
    thBandwidth: "Bandwidth",
    thTraffic: "Traffic",
    thDdos: "DDoS Protection",
    thActions: "Actions",
    rowTooltip: "View offer",
    sortTip: "Click column headers to sort",
    filterLabel: "Category",
    clearFilters: "Reset filters",
    showFullContent: "Show full content",
    perPage: "per page",
    pageInfo: (from, to, total) => `${from}–${to} of ${total} products`,
    period: { monthly: "/ mo", yearly: "/ yr", "one-time": "one-time" },
  },
  nav: {
    home: "Home",
    compare: "Compare",
    submit: "Submit Provider",
    language: "Language",
  },
  hero: {
    badge: "Updated 2026",
    headline_1: "Find the perfect",
    headline_2: "Hosting Provider",
    sub: "Compare the best German hosting providers for webspace, VServers, Discord bots, game servers and more – free and independent.",
    cta: "Compare now",
    stats: [
      { value: "20+", label: "Providers" },
      { value: "100%", label: "Free" },
      { value: "2026", label: "Up to date" },
    ],
  },
  table: {
    title: "Hosting Providers Comparison",
    count: (n, total) => `${n} of ${total} providers`,
    search: "Search",
    searchPlaceholder: "Search providers...",
    sortTip: "Click column headers to sort",
    filterLabel: "Filter by:",
    filterAll: "All",
    visit: "Visit",
    provider: "Provider",
    action: "Action",
    noResults: "No providers found",
    loading: "Loading...",
    details: "Details",
    rowTooltip: "More Info",
    productRowTooltip: "View Product",
  },
  features: {
    webspace: "Webspace",
    domains: "Domains",
    vserver: "VServer",
    dedi: "Dedicated",
    discordbots: "Discord Bots",
    musicbots: "Music Bots",
    licenses: "Licenses",
    teamspeak: "TeamSpeak",
    gameserver: "Game Servers",
  },
  detail: {
    title: "Provider Details",
    visit: "Visit Website",
    close: "Close",
    featuresTitle: "Available Services",
    available: "Available",
    unavailable: "Not available",
  },
  provider: {
    backToOverview: "Back to Overview",
    since: "Since",
    services: "Available Services",
    productsTitle: "Products & Offers",
    free: "free",
    visitWebsite: "Visit Website",
    notFound: "Provider not found",
    thProduct: "Product",
    thCategory: "Category",
    thPrice: "Price",
    period: { monthly: "/ month", yearly: "/ year", "one-time": "one-time" },
  },
  product: {
    backToProvider: "Back to Provider",
    noDescription: "No description available.",
    allProducts: "View all products",
    visitWebsite: "Visit Website",
    toProduct: "Go to Product",
    sidebarTitle: "Provider",
    since: "Since",
    free: "Free",
    notFound: "Product or provider not found",
    period: { monthly: "per month", yearly: "per year", "one-time": "one-time" },
  },
  categories: {
    webspace: "Webspace", vserver: "VServer", dedi: "Dedicated Server",
    gameserver: "Game Server", teamspeak: "TeamSpeak", discordbots: "Discord Bots",
    musicbots: "Music Bots", domains: "Domains", other: "Other",
  },
  specs: {
    title: "Technical Specifications",
    cpu_type: "CPU Type",
    cpu_cores: "CPU Cores",
    ram_type: "RAM Type",
    ram_size: "RAM Size",
    storage_type: "Storage Type",
    storage_size: "Storage Size",
    bandwidth: "Bandwidth",
    ddos_protection: "DDoS Protection",
    traffic: "Incl. Traffic",
    noSpecs: "No technical specifications provided",
  },
  benefits: {
    title: "Why use our comparison?",
    items: [
      {
        title: "Clear Overview",
        desc: "All important information at a glance. Compare offers quickly and easily.",
      },
      {
        title: "Fast",
        desc: "Find the right provider for your requirements in seconds.",
      },
      {
        title: "Free",
        desc: "Our comparison is completely free and non-binding.",
      },
      {
        title: "Up to Date",
        desc: "Our database is regularly updated so you always find the latest providers.",
      },
    ],
  },
  listing: {
    badge: "Get listed",
    title: "Get your service listed",
    subtitle: "Do you run a hosting service and want to appear on Hosting-Community for free? Just reach out – we'll review your listing and sort out the details with you.",
    option1_title: "By Email",
    option1_desc: "Send us a short email with your offer, your website, and the services you provide.",
    option1_cta: "Send Email",
    option1_address: "info@hosting-community.de",
    option2_title: "Via Discord",
    option2_desc: "Join our Discord server and open a ticket in the right channel – we'll respond promptly.",
    option2_cta: "Join Discord",
    note: "Listing is free of charge. We reserve the right to decline providers without giving reasons.",
  },
  cookie: {
    text: "We only use technically necessary cookies to save your language preference. No tracking or analytics cookies are used.",
    accept: "Got it",
    decline: "Decline",
    privacy: "Privacy Policy",
  },
  reviews: {
    title: "Reviews",
    avgRating: "Average Rating",
    noReviews: "No reviews yet for this provider.",
    writeReview: "Write a Review",
    loginToReview: "Log in to write a review.",
    formTitle: "Your Review",
    titleLabel: "Title",
    titlePlaceholder: "Brief summary of your experience",
    commentLabel: "Review",
    commentPlaceholder: "Share your experience with this provider...",
    overallStars: "Overall Rating",
    priceStars: "Value for Money",
    supportStars: "Support",
    speedStars: "Performance",
    submit: "Submit Review",
    submitting: "Submitting...",
    successMsg: "Your review was submitted and will appear after admin approval.",
    pendingBadge: "Pending",
    approvedBadge: "Approved",
    rejectedBadge: "Rejected",
    providerReply: "Provider Response",
    replyLabel: "Write Response",
    replyPlaceholder: "Your response to this review...",
    saveReply: "Save Response",
    alreadyReviewed: "You have already reviewed this provider.",
    basedOn: (n) => `${n} review${n !== 1 ? 's' : ''}`,
    loginCta: "Sign In",
    registerCta: "Create Account",
    orCreate: "or",
  },
  user: {
    loginTitle: "Welcome Back",
    registerTitle: "Create Account",
    accountTitle: "My Account",
    myReviews: "My Reviews",
    email: "Email",
    password: "Password",
    displayName: "Display Name",
    displayNamePlaceholder: "How should your name be displayed?",
    loginBtn: "Sign In",
    registerBtn: "Register",
    loggingIn: "Signing in...",
    registering: "Creating account...",
    logoutBtn: "Log Out",
    navLogin: "Sign In",
    navAccount: "My Account",
    noAccount: "Don't have an account?",
    otherPortals: "Are you an admin or provider?",
    adminPortal: "Admin Area",
    providerPortal: "Provider Portal",
    hasAccount: "Already have an account?",
    noReviews: "You haven't written any reviews yet.",
    pendingNote: "Pending reviews will appear after admin approval.",
    reviewFor: "Review for",
    viewProvider: "View Provider",
  },
  footer: {
    tagline: "The independent hosting comparison for the German-speaking community.",
    links: "Links",
    listProvider: "Get listed",
    contact: "Contact",
    imprint: "Imprint",
    privacy: "Privacy Policy",
    copyright: "© 2026 Hosting-Community. All rights reserved.",
  },
};
